export const home: string = '/';
export const policy: string = '/policy';
